import { SET_AUTHENTICATED_USER, SIGNOUT } from "./mutations";
import axios from "axios";
import moment from "moment";

export default {
  state: {
    usernameNew: localStorage.getItem("userNameNew") || null,
    userId: localStorage.getItem("user_id") || null,
    partners: localStorage.getItem("user_partners")
      ? JSON.parse(localStorage.getItem("user_partners"))
      : [],
    info: localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : [],
    token: localStorage.getItem("token") || null,
    tokenGivenAt: localStorage.getItem("tokenGivenAt")
      ? moment(localStorage.getItem("tokenGivenAt"))
      : null,
    _allAlliance: [
      {
        name: "Dreambox",
        logo: "AcademicPartner/dreambox.png",
      },
      {
        name: "Lectura Inteligente",
        logo: "AcademicPartner/lectura_inteligente.png",
      },
      {
        name: "Kn·spire",
        logo: "AcademicPartner/knspire.png",
      },
      {
        name: "Literacy Pro",
        logo: "AcademicPartner/litpro.png",
      },
      {
        name: "Literacy Pro Library",
        logo: "AcademicPartner/litprolibrary.png",
      },
      {
        name: "TrueFlix",
        logo: "AcademicPartner/trueflix.png",
      },
    ],
  },
  mutations: {
    [SET_AUTHENTICATED_USER](state, payload) {
      state.un = localStorage.getItem("userNameNew") || null;
      state.usernameNew = payload.userInfo.userName;
      state.userId = payload.userInfo.auth_key;
      state.partners = payload.partners;
      state.token = payload.accessToken;
      state.tokenGivenAt = moment(moment.now());
      state.info = {
        ...payload.userInfo,
        userNameNew: payload.userName,
		userName: payload.userName,
      };

      const userType = state.info.userType.toLowerCase();
      if (userType.indexOf("_alliance") > -1) {
        const partnersNames = state.partners.map((p) => p.name);
        state.partners = [].concat(
          state.partners,
          state._allAlliance
            .filter((a) => {
              return partnersNames.indexOf(a.name) == -1;
            })
            .map((a) => {
              a.clase = [];
              a.disabled = true;
              return a;
            })
        );
      }

      localStorage.setItem("user_id", state.userId);
      localStorage.setItem("user", JSON.stringify(state.info));
      localStorage.setItem("user_partners", JSON.stringify(state.partners));
      localStorage.setItem("token", state.token);
      localStorage.setItem(
        "tokenGivenAt",
        state.tokenGivenAt.format("YYYY-MM-DD HH:mm")
      );
    },
    [SIGNOUT](state) {
      state.userId = null;
      state.partners = [];
      state.info = null;
      state.token = null;
      localStorage.clear();
    },
  },
  actions: {
    async attemptSigninIn({ commit }, payload) {
      try {
        let response = await axios.post(
          `${process.env.VUE_APP_API_URL}/api2.0/user/login/partners`,
          {
            userName: payload.username,
            password: payload.password,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = {
          ...response.data,
          userNameNew: localStorage.getItem("userNameNew") || null,
          userName: payload.username,
        };

        commit(SET_AUTHENTICATED_USER, data);
        return null;
      } catch (error) {
        return "El usuario no es correcto o no tiene permisos para acceder a esta plataforma.";
      }
    },
  },
  getters: {
    isAuthenticated: (state) => {
      return !!state.userId;
    },
    partners: (state) => {
      return state.partners.slice();
    },
  },
};
